<script lang="ts">
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import type { Snippet } from "svelte"
  import { titleVariants } from "."
  import { getDialogRootContext } from "./DialogRoot.svelte"

  type Props = BaseProps<"h2"> & {
    class?: string | undefined | null
    children?: Snippet
  }

  let { class: cssClass = "", children, ...restProps }: Props = $props()

  const rootCtx = getDialogRootContext()
</script>

<h2
  class={cn(titleVariants({ variant: $rootCtx.variant }), cssClass)}
  id={$rootCtx.titleId}
  {...restProps}
>
  {@render children?.()}
</h2>
